import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	ALL: `${RouteNames.LICENSE}-all`,
	BY_USER: `${RouteNames.LICENSE}-by-user`,
});
